import { render, staticRenderFns } from "./appealFeedbackDialog.vue?vue&type=template&id=cfc552a8&scoped=true"
import script from "./appealFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./appealFeedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./appealFeedbackDialog.vue?vue&type=style&index=0&id=cfc552a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc552a8",
  null
  
)

export default component.exports